import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { FlashService } from "../../flash/flash.service";
import { ErrorService } from "../../services/error.service";
import { ExitChecklistService } from "../../services/exit-checklist.service";
import { OffboardingService } from "../../services/offboarding.service";

@Component({
  selector: "app-exit-checklist",
  templateUrl: "./exit-checklist.component.html",
  styleUrls: ["./exit-checklist.component.css"],
})
export class ExitChecklistComponent implements OnInit {
  constructor(
    private service: ExitChecklistService,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService,
    private offboardingService : OffboardingService,
    private router: Router
  ) {}

  user: any = {};
  errors;
  currentUser;
  public form: FormGroup;
  unsubcribe: any
  generate:boolean = false
  output_data:any = []
  exp_ans = [];
  showform:boolean;
  inValid: boolean = false;
  public fields: any;
  public elementName = [];
  public formsStatus: Object = {};

  ngOnInit() {

    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.getOffboardingEmployeeDetails();
    
    this.fields = JSON.parse(localStorage.getItem('exit_checklist_employee'));

    const date = new Date();

    this.generateForm();
    this.getpd_answer();
  }

  generateForm(){
     this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields))
    })
    this.form=new FormGroup({});
    this.fields.forEach(x=>{
      if (x.type=='checkbox')
      {
        this.form.addControl(x.name,new FormGroup({}))
        x.options.forEach(o=>{
          (this.form.get(x.name) as FormGroup).addControl(o.key,new FormControl(false))
        })
      }
      else
      {
      this.form.addControl(x.name,
        new FormControl(x.value ||'',x.required?Validators.required:null))
      }
    })
    this.getFields(this.output_data)
  }

  getFields(data) {
    return this.fields
  }

  cc() {
    this.exp_ans = [];
    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);
    
    keys_data.forEach((element, index) => {
      var item = this.fields.find((item) => item.name === element);
      if ((typeof value_data[index] === "object") === true) {
        var obj = value_data[index];
        var keys = Object.keys(obj);
        var filtered = keys.filter(function (key) {
          return obj[key];
        });

        this.exp_ans.push({ name: item.name,id: item.id, ans: `${filtered}` });
      } else {
        this.exp_ans.push({ name: item.name,id: item.id, ans: value_data[index] });
      }
      if(value_data[index] === undefined){
        return this.inValid = true
     }
    });

    this.inValid = false;
    let obj = Object.values(this.form.value);

    obj.forEach((element) => {
      if (element === "") {
        this.inValid = true;
      }
    });

    this.elementName = [];

    this.exp_ans.forEach(ele => {      
      if(!ele.ans){
        this.elementName.push(ele.name);     }
    });

    if(this.elementName.length){
      return this.inValid = true
    }

    if(this.inValid === false) {
      this.onSubmit()
    };
  }

  answers:any[]= [];
  tem:any;
  getpd_answer(){
    this.spinnerService.show()
    this.service.getAnswerExitChecklistEmp(this.currentUser.id).subscribe(
      (data) => {
        this.tem = data.body;
        for (let f of this.tem.questions) {
          if (f.type == 'checkbox') {
            f.answer = f.answer.split(",");
          } 
        }
        
        this.answers = this.tem.questions;
        const arr = this.answers
        if(arr.length > 0){
          this.showform = false
        }else{
          this.showform = true
        }
        this.spinnerService.hide()
      },
      (err) => {
        this.spinnerService.hide()
        console.log("Get Exit Checklist Employee Answers Error:", err);
      }
    );
  }

  onSubmit() {
    this.spinnerService.show();
    const payload = {
      emp_id: this.currentUser.id.toString(),
      data: this.exp_ans,
    };
    
    this.service.createExitChecklist(payload).subscribe(
      (data) => {
        if (data.body["success"]) {
          this.flashService.show(data.body["message"], "alert-success");
          this.getpd_answer()
        
        } else {
          this.errors = data.body["result"];
          this.flashService.show(data.body["message"], "alert-success");
          this.getpd_answer()
        
        }
        this.spinnerService.hide()
        this.getOffboardingEmployeeDetails();
      },
      (error) => {
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
        this.flashService.show(error.message["message"], "alert-danger");
      }
    );
  }

  stringToDate(value) {
    const dateObject = {
      date: {
        year: value.getFullYear(),
        month: value.getMonth() + 1,
        day: value.getDate(),
      },
    };
    return dateObject;
  }

  dateToString(value) {
    const dateString =
      value.date.year +
      "-" +
      (value.date.month < 9 ? "0" : "") +
      value.date.month +
      "-" +
      (value.date.day < 10 ? "0" : "") +
      value.date.day;
    return dateString;
  }

  getOffboardingEmployeeDetails(){
    this.spinnerService.show()
    
    this.offboardingService.getOffboardingEmployeeDetails(this.currentUser.id.toString()).subscribe(
      (data) => {

        this.formsStatus = data.body.data;
        if (this.formsStatus['personal_details_status'] === 'notSubmitted') {
          this.router.navigate(["offboarding/personal-details"]);
        } else if(this.formsStatus['exit_interview_status'] === 'notSubmitted'){
          this.router.navigate(["offboarding/exit-form"]);
        }
        this.spinnerService.hide()
      },
      (err) => {
        this.spinnerService.hide()
        console.log("Get Offboarding Employee Details Error:", err);
      }
    );
  }
}


// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/exit-checklist/exit-checklist.component.ts